import {
	DONOR_TYPE_ENUM,
	FERTILITY_ROLE_ENUM,
	FERTILITY_STATUS_ENUM,
	type FertilityRoleEnum,
	type FertilityStatusEnum,
	GENDER_ENUM,
	JOURNEY_TYPE_ENUM,
	type JourneyTypeEnum,
} from "../../types/onboarding";

export interface StatusFlowRule {
	roles: FertilityRoleEnum[];
	s7: { show: boolean; exclude: JourneyTypeEnum[] };
	s8: { show: boolean };
}

export interface OnboardingConfig {
	enums: {
		gender: readonly string[];
		fertilityStatus: readonly string[];
		fertilityRole: readonly string[];
		journeyType: readonly string[];
		donorType: readonly string[];
	};
	flow: Record<FertilityStatusEnum, StatusFlowRule>;
}

// Hardcoded from contract §3/§4. Replaced at runtime by GET /api/onboarding/config
// when deployed (see flowConfig.ts). Shape MUST match the API response.
export const FALLBACK_ONBOARDING_CONFIG: OnboardingConfig = {
	enums: {
		gender: GENDER_ENUM,
		fertilityStatus: FERTILITY_STATUS_ENUM,
		fertilityRole: FERTILITY_ROLE_ENUM,
		journeyType: JOURNEY_TYPE_ENUM,
		donorType: DONOR_TYPE_ENUM,
	},
	flow: {
		trying_to_conceive: {
			roles: [
				"primary_patient",
				"partner",
				"support_person",
				"exploring_options",
			],
			s7: { show: true, exclude: [] },
			s8: { show: true },
		},
		preserving_fertility: {
			roles: [
				"primary_patient",
				"partner",
				"support_person",
				"exploring_options",
			],
			s7: { show: true, exclude: ["iui", "surrogacy"] },
			s8: { show: true },
		},
		egg_sperm_donor: {
			roles: [],
			s7: { show: false, exclude: [] },
			s8: { show: false },
		},
		surrogacy: {
			roles: [
				"surrogate",
				"intended_parent",
				"support_person",
				"exploring_options",
			],
			s7: { show: true, exclude: ["iui", "ivf"] },
			s8: { show: true },
		},
		currently_pregnant: {
			roles: ["primary_patient", "partner", "support_person"],
			s7: { show: false, exclude: [] },
			s8: { show: true },
		},
		early_parenting: {
			roles: ["parent", "support_person", "exploring_options"],
			s7: { show: false, exclude: [] },
			s8: { show: false },
		},
	},
};
